<template>
  <div class="form">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      label-width="0"
      status-icon
      :inline-message="true"
    >
      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          placeholder="请输入账户"
          prefix-icon="el-icon-user"
          clearable
        />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          placeholder="请输入密码"
          prefix-icon="el-icon-lock"
          type="password"
          show-password
        />
      </el-form-item>
      <div style="margin-bottom: 10px">
        <el-checkbox v-model="checked" class="remeberPwd" @change="remPw">
          记住账户和密码
        </el-checkbox>
      </div>
      <!-- 是否开启验证模式 -->
      <el-form-item v-if="captchMode" prop="code">
        <el-col :span="16">
          <el-input
            clearable
            v-model="loginForm.code"
            :autosize="true"
            placeholder="请输入验证码"
            prefix-icon="iconfont icon-anquan1"
          />
        </el-col>
        <el-col :span="8">
          <div @click="refreshCode">
            <img :src="loginForm.image" alt="" />
          </div>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleLogin"> 登录 </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getCaptcha } from "@/api/user";
import mobileSite from "@/config/mobileSite";
import { resetRouter } from "@/router/index";
export default {
  data() {
    return {
      checked: Boolean(localStorage.getItem("checkedStatus")),
      // 是否开启验证模式
      captchMode: mobileSite.captchaMode,
      // 登录表单
      loginForm: {
        // 账户
        username: "",
        // 密码
        password: "",
        // 客户端类型
        clientType: "APP",
        // 验证码的值
        code: "",
        // 验证码的索引
        key: "",
        // 预加载白色背景
        image:
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      },
      // 记住密码
      // 输入验证
      loginRules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码长度最少为6位", trigger: "blur" },
        ],
        code: [
          {
            min: 5,
            max: 5,
            message: "请输入的正确的位数验证码",
            trigger: "blur",
          },
        ],
        // username:loginForm.username
        // 记住密码
      },
    };
  },
  created() {
    this.checkLocalTime();
    resetRouter();
    if (localStorage.getItem("checkedStatus") == "false") {
      this.checked = !Boolean(localStorage.getItem("checkedStatus"));
    } else {
      this.loginForm.username = localStorage.getItem("username");
      this.loginForm.password = localStorage.getItem("password");
    }
  },
  mounted() {},
  watch: {
    // loginForm: {
    //   // 对象内部的监听需要用到深度监听
    //   handler: function (value, oldValue) {
    //     if (value.username == "" || value.password == "") {
    //       this.checked = Boolean(false);
    //     } else {
    //       this.checked = Boolean(true);
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    // 点击获取图形验证码
    refreshCode() {
      getCaptcha().then((res) => {
        const data = res.data;
        this.loginForm.key = data.key;
        this.loginForm.image = data.image;
      });
    },
    // 记住密码
    remPw(checked) {
      localStorage.setItem("checkedStatus", checked);
      // if (checked == true) {
      //   localStorage.setItem("username", this.loginForm.username);
      //   localStorage.setItem("password", this.loginForm.password);
      // } else {
      //   localStorage.setItem("username", "");
      //   localStorage.setItem("password", "");
      // }
    },
    // 账户密码保留七天
    // clearUp() {
    //   let sevenDay = new Date();
    //   sevenDay.setTime(sevenDay.getTime() + 7 * 60 * 60 * 1000 * sevenDay);
    // },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "登录中,请稍后...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$store
            .dispatch("loginByUserName", this.loginForm)
            .then(() => {
              if (this.checked == true) {
                localStorage.setItem("username", this.loginForm.username);
                localStorage.setItem("password", this.loginForm.password);
              }
              loading.close();
              this.$router.push({ path: "/temporaryPerson" });
            })
            .catch(() => {
              loading.close();
              this.refreshCode();
              // this.checked = Boolean(false);
              // this.loginForm.username = "";
              // this.loginForm.password = "";
              // this.loginForm.code = "";
              localStorage.setItem("username", "");
              localStorage.setItem("password", "");
            });
        }
      });
    },
    // 检查localstorage,time超时session失效，重新获取图形验证码
    checkLocalTime() {
      this.$store.dispatch("getConfig").then(() => {
        this.refreshCode();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.form {
  margin: 0 auto;
  width: 350px;
  .el-form-item {
    margin-bottom: 10px;
    .el-input {
      /deep/ .el-input__inner {
        color: #000;
        // background-color: rgba(0, 0, 0, 0.6);
        background-color: rgba(255, 255, 255, 1);
      }
      /deep/ input:focus {
        outline: none;
        border: 1px solid #606266;
      }
      /deep/ .el-input__prefix {
        width: 25px;
      }
      /deep/ i {
        color: #000;
      }
      ::-webkit-input-placeholder {
        color: #000;
      }
    }
    /deep/ .el-form-item__content {
      width: 100%;
      .el-col {
        text-align: right;
        img {
          height: 40px;
          border-radius: 4px !important;
          opacity: 0.7;
        }
      }
    }
    .el-button {
      width: 100%;
      border: none;
      color: #ffffff;
      font-weight: bold;
      font-size: 18px;
      border-radius: 4px;
      background-color: #1563c3;
    }
  }
}
</style>
